<template>
  <button class="filter-button" @click="handleFilterClick">
    <img class="filter-icon" alt="filter" :src="filterIcon" />
    <span class="filter-text">Filtrar</span>
  </button>
</template>

<script>
// Icons
import filterIcon from '@/static/icons/ic_filter.svg';

export default {
  name: 'FilterButton',
  computed: {
    filterIcon: () => filterIcon,
  },
  methods: {
    handleFilterClick() {
      this.$emit('filter-click');
    },
  },
};
</script>
